const D = 500, E = "UIkit.Layout.Drawer", _ = "right", t = "bottom";
export {
  _ as DEFAULT_DRAWER_DESKTOP_ANCHOR,
  t as DEFAULT_DRAWER_MOBILE_ANCHOR,
  E as DEFAULT_DRAWER_TEST_ID,
  D as DEFAULT_DRAWER_WIDTH
};
//# sourceMappingURL=constants17.mjs.map
